import React, { Component } from "react";
import {
  HelpBlock,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Signup.css";
import { Auth } from "aws-amplify";


export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      given_name: "",
      family_name: "",
      company_name: "",
      nena_id: "",
      password: "",
      confirmPassword: "",
      phone_number: "",
      username: "",
      name: "",
      confirmationCode: "",
      newUser: null
    };
  }

  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.state.given_name.length > 0 &&
      this.state.family_name.length > 0 &&
      this.state.company_name.length > 0 &&
      this.state.nena_id.length > 0 &&
      this.state.password.length > 0 &&
      this.state.phone_number.length > 0 &&
      this.state.password === this.state.confirmPassword
    );
  }

  validateConfirmationForm() {
    return this.state.confirmationCode.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();
  
    this.setState({ isLoading: true });
  
    try {
      const newUser = await Auth.signUp({
        username: this.state.email,
        password: this.state.password,
        attributes:{
          given_name: this.state.given_name,
          family_name: this.state.family_name,
          phone_number: this.state.phone_number,
          nickname: this.state.company_name,
          gender: this.state.nena_id
        }
      });
      this.setState({
        newUser
      });
    } catch (e) {
      alert(e.message);
    }
  
    this.setState({ isLoading: false });
  }
  
  handleConfirmationSubmit = async event => {
    event.preventDefault();
  
    this.setState({ isLoading: true });
  
    try {
      await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
      await Auth.signIn(this.state.email, this.state.password);
  
      this.props.userHasAuthenticated(true);
      this.props.history.push("/");
    } catch (e) {
      alert(e.message);
      this.setState({ isLoading: false });
    }
  }
  

  renderConfirmationForm() {
    return (
      <form onSubmit={this.handleConfirmationSubmit}>
        <FormGroup controlId="confirmationCode" bsSize="large">
          <ControlLabel>Confirmation Code</ControlLabel>
          <FormControl
            autoFocus
            type="tel"
            value={this.state.confirmationCode}
            onChange={this.handleChange}
          />
          <HelpBlock>Please check your email for the code sent to you from no-reply@verificationemail.com</HelpBlock>
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateConfirmationForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Verify"
          loadingText="Verifying…"
        />
      </form>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>
        <FormGroup controlId="company_name" bsSize="small">
          <ControlLabel>Organization Name</ControlLabel>
          <FormControl
            autoFocus
            placeholder="Company, Institution, Municipality, Tribal Entity, etc."
            type="company_name"
            value={this.state.company_name}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="nena_id" bsSize="small">
          <ControlLabel>NENA Company ID</ControlLabel>
          <FormControl
            autoFocus
            placeholder="Your NENA Company ID"
            type="nena_id"
            value={this.state.nena_id}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="given_name" bsSize="small">
          <ControlLabel>First Name</ControlLabel>
          <FormControl
            autoFocus
            placeholder="First name"
            type="given_name"
            value={this.state.given_name}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="family_name" bsSize="small">
          <ControlLabel>Last Name</ControlLabel>
          <FormControl
            autoFocus
            placeholder="Last name"
            type="family_name"
            value={this.state.family_name}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="phone_number" bsSize="small">
          <ControlLabel>Phone Number</ControlLabel>          
          <FormControl
            autoFocus
            placeholder="Phone number with country code"
            type="phone_number"
            value={this.state.phone_number}
            onChange={this.handleChange}
          />
          <HelpBlock>example: +12065551234</HelpBlock>
        </FormGroup>

        <FormGroup controlId="email" bsSize="small">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            autoFocus
            placeholder="email@example.com"
            type="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="small">
          <ControlLabel>Password</ControlLabel>
          <FormControl
            value={this.state.password}
            onChange={this.handleChange}
            type="password"
            
          />
          <HelpBlock>Use 8 or more characters with a mix of letters, numbers and symbols.</HelpBlock>
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="small">
          <ControlLabel>Confirm Password</ControlLabel>
          <FormControl
            value={this.state.confirmPassword}
            onChange={this.handleChange}
            type="password"
          />
        </FormGroup>

        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Signup"
          loadingText="Signing up…"
        />
        <HelpBlock>When you click Signup, you will recieve an email 
          from no-reply@verificationemail.com containing a verification code that you will use to verify your email address.</HelpBlock>
        <HelpBlock>By clicking signup you agree to the terms of use for the ALIPro Web PS/ALI service.</HelpBlock>
      </form>
    );
  }

  render() {
    return (
      <div className="Signup">
        {this.state.newUser === null
          ? this.renderForm()
          : this.renderConfirmationForm()}
      </div>
    );
  }
}
